export enum WordTreeType {
    prefix,
    suffix,
    double
}